import { useRecoilValueLoadable } from 'recoil';
import {
  IPermissions,
  permissionsSelector,
} from '../../../recoil/selectors/permissionsSelector';
import { useEffect } from 'react';
import { IUserAtom, Role, user } from '../../../recoil/atoms/user';

const CallTranscriptionRedirect = ({
  match: {
    params: { callXd },
  },
}) => {
  const userLoadable = useRecoilValueLoadable(user);
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);

  useEffect(() => {
    const userid = (userLoadable?.contents as IUserAtom).userid;
    const role = (permissionsLoadable?.contents as IPermissions).role;

    if (!callXd || !userid || !role) return;

    let href = `/my-profile/${userid}/call-history`;
    if ([Role.MANAGER, Role.ADMIN, Role.SUPERADMIN].includes(role)) {
      href = `/history/call-history`;
    }

    window.location.href = `${href}?transcription=${callXd}`;
  }, [callXd, userLoadable?.contents, permissionsLoadable?.contents]);

  return null;
};

export default CallTranscriptionRedirect;
